import { Method } from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

import { Business } from '../../types/businessDetails.types';
import { endpoints, methods, request } from '../lib/api';

interface IBusinessDetailsResponse {
  data?: {
    data?: Business;
  };
}

export function useGetBusiness(
  businessId: string,
  options?: UseQueryOptions<Business, Error>,
): UseQueryResult<Business> {
  return useQuery<IBusinessDetailsResponse, Error, Business>(
    'businessProfile',
    () => request(endpoints.businessProfile(businessId), methods.GET as Method),
    {
      //   enabled: !initialBusinessData,
      select: (data) => data?.data?.data,
      ...options,
    },
  );
}

export function useGetWorkplace(
  workplaceId: string,
  options?: UseQueryOptions<Business, Error>,
): UseQueryResult<Business> {
  return useQuery<IBusinessDetailsResponse, Error, Business>(
    'workplace',
    () => request(endpoints.workplace(workplaceId), methods.GET as Method),
    {
      //   enabled: !initialBusinessData,
      select: (data) => data?.data?.data,
      ...options,
    },
  );
}
